<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{this.lastReevaluatedBy}}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
        </ng-template>
    </incident-dialog-content>
    <h2>Collection Details</h2>
    <form [formGroup]="incidentForm" autocomplete="off" *ngIf="showUserInput">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Amount Due" name="amountDue" [isRequired]="true"></user-input>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Interest Due" name="interestDue" [isRequired]="false"></user-input>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Penalty Due" name="penaltyDue" [isRequired]="false"></user-input>
                </div>
            </div>
        </fieldset>
    </form>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>
